import 'url-search-params-polyfill'

type QUERY = Record<string, string | number | boolean | undefined>

export function emitRouterChange() {
  const states = ['not-auth', 'being-auth', 'auth-success', 'auth-fail']
  window._MTDPAuth_ = {
    state: states[0]!,
    callbackQueue: [],
  }
  window.$bus.$emit('route-change')
}

export default function getURLSearchParam(key: string, url = window.location.search) {
  const searchParams = getURLSearchParams(url)
  const value = searchParams.get(key)
  return !value || value === 'undefined' ? '' : value
}

export const toUrlParams = (p: QUERY = {}): string =>
  Object.keys(p || {})
    .filter((key) => p[key])
    .map((key) => `${key}=${encodeURIComponent(p[key] || '')}`)
    .join('&')

export function getURLSearchParams(url = window.location.search) {
  return new URLSearchParams(url)
}

export function genUrl(url: URL, urlSearchParams: URLSearchParams) {
  // protocal + (host ? '//' : '') + host + pathname
  const destSearch = urlSearchParams.toString()
  return `${url.protocol}${url.host ? '//' : ''}${url.host}${url.pathname}${destSearch ? '?' + destSearch : ''}${
    url.hash
  }`
}

export function changeURLSearchParam(destUrl: string, query: QUERY) {
  const destURL = new URL(destUrl)
  let destSearchParams = destURL.searchParams
  if (!destSearchParams) {
    destSearchParams = getURLSearchParams(destURL.search)
  }
  if (query) {
    for (const key in query) {
      if (query[key] !== undefined && query[key] !== null && query[key] !== '') {
        destSearchParams.set(key, String(query[key]))
      } else {
        destSearchParams.delete(key)
      }
    }
  }
  return genUrl(destURL, destSearchParams)
}

export function removeURLParameters(url = '', parameters: string[] = []) {
  const urlParts = url.split('?')
  if (urlParts.length >= 2) {
    const pars = urlParts[1].split(/[&;]/g)
    const filterPars = pars.filter(
      (par) =>
        !parameters.some((parameter) => {
          const prefix = encodeURIComponent(parameter) + '='
          return par.lastIndexOf(prefix, 0) !== -1
        }),
    )

    return urlParts[0] + (filterPars.length > 0 ? '?' + filterPars.join('&') : '')
  }
  return url
}

export function replaceState(query: QUERY) {
  const newUrl = changeURLSearchParam(window.location.href, query)
  if (window.location.href === newUrl) return
  window.history.replaceState('', '', changeURLSearchParam(window.location.href, query))
  emitRouterChange()
}

export function pushState(query: QUERY) {
  window.history.pushState('', '', changeURLSearchParam(window.location.href, query))
  emitRouterChange()
}
